module.exports = __webpack_public_path__ + "static/media/onboard.ed6033da.png";